import styled, { css } from 'styled-components'
import { containerDefault } from '../../../lib/styles/Container'

export const Wrapper = styled.nav`
  background-color: ${props => props.theme.colors.bluetiful[3]};
  padding: 0.5em 0.75em;
  transition: box-shadow 0.2s ease-in-out;
`

export const Container = styled.div`
  ${containerDefault}
  margin-inline: auto;
`

export const NavList = styled.div`
  align-items: center;
  display: flex;
  gap: 3rem;
  justify-content: space-between;
`

export const Group = styled.ul<{ isDesktop?: boolean; isMobile?: boolean }>`
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  color: ${props => props.theme.colors.white[1]};
  display: flex;

  ${({ isDesktop }) =>
    isDesktop &&
    css`
      display: none;

      @media screen and (min-width: 1024px) {
        display: flex;
      }
    `}

  ${({ isMobile }) =>
    isMobile &&
    css`
      display: flex;

      @media screen and (min-width: 1024px) {
        display: none;
      }
    `}
`

export const Text = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`

export const IconWrapper = styled.span`
  display: flex;
`

export const AnnouncementBannerText = styled.span`
  color: ${props => props.theme.colors.white[1]};
  font-family: Source Sans Pro;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;

export const AnnouncementBannerLinkStyled = styled.div`
  display: flex;
  gap: 0.5em;
  align-items: center;
  cursor: pointer;
  color: ${props => props.theme.colors.white[1]};
  font-family: Source Sans Pro;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 110%;
  `;